const EXIT_INTENT_SUCCESS_MESSAGE = "Thanks for signing up! Keep an eye out for our latest updates.";
const EXIT_INTENT_ERROR_MESSAGE = "Something went wrong. Please try again.";
const EXIT_INTENT_VALIDATION_ERROR_CLASS = "exit-intent-email-error-msg";
const EXIT_INTENT_EMAIL_INPUT_ID = "subscribe-exit-intent-email";

var isExitIntentPopupOpen = false;

function ExitIntentPopup(selector) {
    this.selector = selector;
    this.popupModalEl = document.querySelector(selector);
    this.popupModal = new bootstrap.Modal(this.popupModalEl);
    this.showPopupFlag = true;
    this.popupDetailObj = {};
    this.idleTimer = null;
    this.lastScrollY = window.scrollY;
    this.lastScrollTime = Date.now();
}

ExitIntentPopup.prototype.isUserLoggedIn = function () {
    return !!window.isUserLoggedIn;
};

ExitIntentPopup.prototype.getExitIntentCookie = function (name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
    return null;
};

ExitIntentPopup.prototype.hasPopupAlreadyShown = function (id) {
    var popupCookie = this.getExitIntentCookie('exitintent_' + id + '_completed');
    return !!popupCookie;
};

ExitIntentPopup.prototype.setPopupCookie = function (action) {
    var expireDays = 1;
    if (action === "cancel") {
        expireDays = this.popupDetailObj.showAfterNDaysOfCancel || 1;
    } else if (action === "submission") {
        expireDays = this.popupDetailObj.showAfterNDaysOfSubmission || 1;
    }
    document.cookie = 'exitintent_' + this.popupDetailObj.id + '_completed=' + new Date().toUTCString() +
        '; path=/; SameSite=Strict; Secure; expires=' +
        new Date(Date.now() + expireDays * 24 * 60 * 60 * 1000).toUTCString() + ';';
};

ExitIntentPopup.prototype.matchWildcardPath = function (pattern, path) {
    var regexPattern = '^' + pattern.replace(/\*/g, '.*') + '$';
    var regex = new RegExp(regexPattern);
    return regex.test(path);
};

ExitIntentPopup.prototype.hasLengthierString = function (array1, array2) {
    if (!array1.length) return true;
    var longestString = array1[0];
    for (var i = 1; i < array1.length; i++) {
        if (array1[i].length > longestString.length) {
            longestString = array1[i];
        }
    }
    for (var j = 0; j < array2.length; j++) {
        if (array2[j].length > longestString.length) {
            return false;
        }
    }
    return true;
};

ExitIntentPopup.prototype.canDisplayedOnThisPage = function (popupDetail) {
    var self = this;
    var currentPageURL = window.location.pathname;

    if ((!popupDetail.pagesToBeAvoided || popupDetail.pagesToBeAvoided.length === 0) &&
        (!popupDetail.pagesToBeDisplayed || popupDetail.pagesToBeDisplayed.length === 0)) {
        return true;
    }

    var isInAvoidedPaths = popupDetail.pagesToBeAvoided && popupDetail.pagesToBeAvoided.includes(currentPageURL);
    if (isInAvoidedPaths) return false;

    var isInDisplayedPaths = popupDetail.pagesToBeDisplayed && popupDetail.pagesToBeDisplayed.includes(currentPageURL);
    if (isInDisplayedPaths) return true;

    var avoidedPathsMatch = [];
    (popupDetail.pagesToBeAvoided || []).forEach(function (path) {
        if (self.matchWildcardPath(path, currentPageURL)) {
            avoidedPathsMatch.push(path);
        }
    });

    var displayedPathsMatch = [];
    (popupDetail.pagesToBeDisplayed || []).forEach(function (path) {
        if (self.matchWildcardPath(path, currentPageURL)) {
            displayedPathsMatch.push(path);
        }
    });

    if (avoidedPathsMatch.length > 0 && displayedPathsMatch.length === 0) return false;
    if (avoidedPathsMatch.length === 0 && displayedPathsMatch.length > 0) return true;
    if (avoidedPathsMatch.length === 0 && displayedPathsMatch.length === 0) return true;
    if (avoidedPathsMatch.length !== 0 && displayedPathsMatch.length !== 0) {
        return self.hasLengthierString(displayedPathsMatch, avoidedPathsMatch);
    }
    return true;
};

ExitIntentPopup.prototype.displayPopup = function (popupObjList) {
    if (window.suppressPopups) return;

    for (var i = 0; i < popupObjList.length; i++) {
        var popupDetail = popupObjList[i];
        if (popupDetail.isEnabled && !this.hasPopupAlreadyShown(popupDetail.id) && this.canDisplayedOnThisPage(popupDetail)) {
            this.popupDetailObj = popupDetail;
            this.initExitIntentTriggers(popupDetail);
            break;
        }
    }
};

ExitIntentPopup.prototype.showPopupModal = function () {
    if (this.showPopupFlag && !isExitIntentPopupOpen && !window.isAnyPopupOpen) {
        if (this.popupDetailObj && this.popupDetailObj.popupTitle && this.popupDetailObj.popupDescription) {
            document.getElementById('exitIntentModalTitle').innerHTML = this.popupDetailObj.popupTitle;
            document.getElementById('exitIntentModalDescription').innerHTML = this.popupDetailObj.popupDescription;
        }

        if (this.popupDetailObj && this.popupDetailObj.buttonText) {
            var ctaBtn = document.getElementById('exitIntentModalCTA');
            if (ctaBtn) {
                ctaBtn.textContent = this.popupDetailObj.buttonText;
            }

            var acceptBtn = document.getElementById('accept-exit-intent');
            if (acceptBtn) {
                acceptBtn.textContent = this.popupDetailObj.buttonText;
            }
        }

        var popupModalObj = bootstrap.Modal.getInstance(this.selector);
        popupModalObj.show();
        this.showPopupFlag = false;
        isExitIntentPopupOpen = true;
        window.isAnyPopupOpen = true;
    }
};

ExitIntentPopup.prototype.hidePopupModal = function () {
    var popupModalObj = bootstrap.Modal.getInstance(this.selector);
    popupModalObj.hide();
    isExitIntentPopupOpen = false;
    window.isAnyPopupOpen = false;
};

ExitIntentPopup.prototype.initExitIntentTriggers = function (popupDetail) {
    var self = this;
    if (popupDetail.enableIdle && popupDetail.idleTime && popupDetail.idleTime > 0) {
        self.displayPopupAfterIdleTime(popupDetail.idleTime);
    }
    if (popupDetail.enableMouseIntent) {
        self.trackMouseExitIntent();
    }
    if (popupDetail.enableRapidScrollUp) {
        self.trackRapidScrollUp();
    }
};

ExitIntentPopup.prototype.displayPopupAfterIdleTime = function (idleTime) {
    var self = this;
    self.resetIdleTimer(idleTime);
    document.addEventListener('mousemove', function () {
        self.resetIdleTimer(idleTime);
    });
    document.addEventListener('keydown', function () {
        self.resetIdleTimer(idleTime);
    });
    document.addEventListener('scroll', function () {
        self.resetIdleTimer(idleTime);
    });
};

ExitIntentPopup.prototype.resetIdleTimer = function (idleTime) {
    var self = this;
    clearTimeout(self.idleTimer);
    self.idleTimer = setTimeout(function () {
        self.showPopupModal();
    }, idleTime * 1000);
};

ExitIntentPopup.prototype.trackMouseExitIntent = function () {
    var self = this;
    document.addEventListener('mouseout', function (e) {
        if (e.clientY <= 0) {
            self.showPopupModal();
        }
    });
};

ExitIntentPopup.prototype.trackRapidScrollUp = function () {
    var self = this;
    window.addEventListener('scroll', function () {
        var currentScrollY = window.scrollY;
        var currentTime = Date.now();

        var scrollDistance = self.popupDetailObj.rapidScrollUpDistance || 200;
        var timeWindow = self.popupDetailObj.rapidScrollUpTimeWindow || 350;

        if (self.lastScrollY - currentScrollY > scrollDistance && currentTime - self.lastScrollTime < timeWindow) {
            self.showPopupModal();
        }
        self.lastScrollY = currentScrollY;
        self.lastScrollTime = currentTime;
    });
};

ExitIntentPopup.prototype.handleExitIntentEnterKeyPress = function (event) {
    if (event.key === "Enter") {
        let inputId = event.target.id;
        if (inputId === EXIT_INTENT_EMAIL_INPUT_ID) {
            this.onExitIntentSignUp();
        }
    }
};

ExitIntentPopup.prototype.onExitIntentSignUp = function () {
    var self = this;
    this.subscribeToExitIntent(`#${EXIT_INTENT_EMAIL_INPUT_ID}`, ".exit-intent-email-validation")
        .then(function (data) { self.handleExitIntentSuccess(data); })
        .catch(function (error) {
            self.handleExitIntentError(error, ".exit-intent-email-validation");
        });
};

ExitIntentPopup.prototype.handleExitIntentSuccess = function (data) {
    this.setPopupCookie("submission");
    this.hidePopupModal();
    var message = (this.popupDetailObj && this.popupDetailObj.successMessage)
        ? this.popupDetailObj.successMessage
        : EXIT_INTENT_SUCCESS_MESSAGE;
    showToast(message, 4000, "success");
};

ExitIntentPopup.prototype.handleExitIntentError = function (error, validationContainerSelector) {
    if (
        validationContainerSelector &&
        $(validationContainerSelector).find(`.${EXIT_INTENT_VALIDATION_ERROR_CLASS}`).length > 0
    ) {
        return;
    }
    showToast(EXIT_INTENT_ERROR_MESSAGE, 5000, "fail");
    console.error("Sign-up failed:", error);
};

ExitIntentPopup.prototype.subscribeToExitIntent = function (emailOrSelector, validationContainerSelector = null) {
    var self = this;
    let subscriptionEmail;
    let skipValidation = false;

    let exitIntentItemId = this.popupDetailObj ? this.popupDetailObj.id : null;

    if (!exitIntentItemId) {
        showToast(EXIT_INTENT_ERROR_MESSAGE, 5000, "fail");
        return Promise.reject("Exit intent item id missing.");
    }

    if (typeof emailOrSelector === "string" && emailOrSelector.startsWith("#")) {
        subscriptionEmail = $(emailOrSelector).val();
    } else {
        subscriptionEmail = emailOrSelector;
        skipValidation = true;
    }

    if (!skipValidation) {
        var validationResult = validateSubscriptionEmail(subscriptionEmail);
        if (!validationResult.valid) {
            if (validationContainerSelector) {
                $(validationContainerSelector)
                    .html(`<p><span class="${EXIT_INTENT_VALIDATION_ERROR_CLASS}">${validationResult.error}</span></p>`);
                $(`#${EXIT_INTENT_EMAIL_INPUT_ID}`).addClass("has-error");
            }

            return Promise.reject(validationResult.error);
        }
        if (validationContainerSelector) {
            $(validationContainerSelector).empty();
            if ($(`#${EXIT_INTENT_EMAIL_INPUT_ID}`).hasClass("has-error")) {
                $(`#${EXIT_INTENT_EMAIL_INPUT_ID}`).removeClass("has-error");
            }
        }
    }

    var body = {
        email: subscriptionEmail,
        exitIntentItemId: exitIntentItemId
    };

    return new Promise((resolve, reject) => {
        $('.loading-overflow-add-cart').show().css("z-index", getMaxZIndex() + 1);

        $.ajax({
            url: '/subscribe/exit-intent',
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify(body),
            headers: {
                RequestVerificationToken: $('input:hidden[name="__RequestVerificationToken"]').val()
            },
            success: function (data) {
                $('.loading-overflow-add-cart').hide();
                if (data === true) {
                    resolve(data);
                } else {
                    reject(EXIT_INTENT_ERROR_MESSAGE);
                }
            },
            error: function (error) {
                $('.loading-overflow-add-cart').hide();
                console.log(error);
                reject(error);
            }
        });
    });
};

$(document).on('click', '#accept-exit-intent', function () {
    if (window.exitIntentPopupInstance) {
        var email = typeof loggedInUserEmail !== "undefined" ? loggedInUserEmail : "";
        window.exitIntentPopupInstance.subscribeToExitIntent(email)
            .then(function (data) { window.exitIntentPopupInstance.handleExitIntentSuccess(data); })
            .catch(function (error) { window.exitIntentPopupInstance.handleExitIntentError(error); });
    }
});

$(document).on('click', '[data-click-fn="onExitIntentSignUp"]', function (e) {
    if (window.exitIntentPopupInstance && typeof window.exitIntentPopupInstance.onExitIntentSignUp === "function") {
        window.exitIntentPopupInstance.onExitIntentSignUp();
    }
});

$(document).on('click', '[data-click-fn="closeExitIntentPopup"]', function (e) {
    if (window.exitIntentPopupInstance && typeof window.exitIntentPopupInstance.hidePopupModal === "function") {
        window.exitIntentPopupInstance.hidePopupModal();
        window.exitIntentPopupInstance.setPopupCookie("cancel");
    }
});

$(document).on('keypress', '[data-keypress-fn="handleExitIntentEnterKeyPress"]', function (e) {
    if (window.exitIntentPopupInstance && typeof window.exitIntentPopupInstance.handleExitIntentEnterKeyPress === "function") {
        window.exitIntentPopupInstance.handleExitIntentEnterKeyPress(e);
    }
});